import { jsx as _jsx } from "react/jsx-runtime";
import { PDF_MAX_ZOOM, PDF_MIN_ZOOM, PDF_ZOOM_STEP, pdfScaleSteps } from "@air/react-pdfjs-viewer";
import { findIndexOfLowestClosestNumber } from "@air/react-pdfjs-viewer/src/utils/findIndexOfLowestClosestNumber";
import { memo } from "react";
import { usePDFZoomContext } from "../contexts/PDFZoomContext";
import { ZoomSlider } from "./ZoomSlider";
export const PDFZoomSlider = /*#__PURE__*/ memo(()=>{
    const { scale: currentZoom, updateScale } = usePDFZoomContext();
    const handleSliderChange = (value)=>{
        const newZoom = value[0];
        updateScale(newZoom);
    };
    const handleZoomOut = ()=>{
        // Find current scale step index
        const currentIndex = findIndexOfLowestClosestNumber(pdfScaleSteps, currentZoom);
        // Go to previous step if possible
        const newIndex = Math.max(0, currentIndex - 1);
        const newZoom = pdfScaleSteps[newIndex];
        updateScale(newZoom);
    };
    const handleZoomIn = ()=>{
        // Find current scale step index
        const currentIndex = findIndexOfLowestClosestNumber(pdfScaleSteps, currentZoom);
        // Go to next step if possible
        const newIndex = Math.min(pdfScaleSteps.length - 1, currentIndex + 1);
        const newZoom = pdfScaleSteps[newIndex];
        updateScale(newZoom);
    };
    return /*#__PURE__*/ _jsx(ZoomSlider, {
        onZoomIn: handleZoomIn,
        onZoomOut: handleZoomOut,
        zoom: currentZoom,
        onSliderChange: handleSliderChange,
        min: PDF_MIN_ZOOM,
        max: PDF_MAX_ZOOM,
        step: PDF_ZOOM_STEP
    });
});
PDFZoomSlider.displayName = "PDFZoomSlider";
